import { render, staticRenderFns } from "./UpdatePlainGold.vue?vue&type=template&id=3fdb7c5c&scoped=true"
import script from "./UpdatePlainGold.vue?vue&type=script&lang=js"
export * from "./UpdatePlainGold.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlainGold.vue?vue&type=style&index=0&id=3fdb7c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb7c5c",
  null
  
)

export default component.exports